import type { SVGProps } from 'react';

export type ArrowRightProps = SVGProps<SVGSVGElement>;

export const ArrowRight = (props: ArrowRightProps) => (
  <svg width="16" height="14" viewBox="0 0 16 14" role="img" aria-hidden {...props}>
    <title>arrow</title>
    <path
      d="M2 7 H13 M9 3 L13 7 L9 11"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);
